import { Input, Pill } from '@recruit-robin/robin-theme/web-components';
import { XClose } from '@recruit-robin/robin-theme/web-icons';
import { useContext, useState } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from '../CandidateQuestionnaireScreen.styles';

export const InputRequirement = ({
  value = [],
  onChange,
  placeholder,
}: {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState('');
  const { dictionary } = useContext(LocalizationContext);

  const handleAddValue = () => {
    const safeValue = value ?? [];
    if (inputValue.trim() && !safeValue.includes(inputValue.trim())) {
      const newValues = [...safeValue, inputValue.trim()];
      onChange(newValues);
      setInputValue('');
    }
  };

  const handleRemoveValue = (valueToRemove: string) => {
    const safeValue = value ?? [];
    const newValues = safeValue.filter((v) => v !== valueToRemove);
    onChange(newValues);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddValue();
    }
  };

  return (
    <Input
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyPress={handleKeyPress}
      placeholder={placeholder ?? dictionary.addMore}
      customCss={classes.input}
      startAdornment={
        (value ?? []).length > 0 ? (
          <div css={classes.pillsContainer}>
            {(value ?? []).map((selectedValue, index) => (
              <Pill
                key={index}
                label={selectedValue}
                style="icon-removable"
                type="subtle-light"
                endIcon={<XClose size={14} />}
                onClick={() => handleRemoveValue(selectedValue)}
              />
            ))}
          </div>
        ) : undefined
      }
    />
  );
};
